// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6035":"7ba673945d1ef543","6129":"4f206837c5a4dbbb"}[chunkId] + ".js";
};